/**
 * Equivalente a isMustChangePassword do backend.
 * MySQL TINYINT(1) / JSON / localStorage podem entregar '0' (truthy em JS)
 * ou 0. Só true | 1 | '1' devem forçar a troca de senha.
 *
 * @param {unknown} value
 * @returns {boolean}
 */
export function isMustChangePassword(value) {
  return value === true || value === 1 || value === '1'
}
